import React, { createContext, useCallback, useContext, useMemo, useReducer } from 'react';

const AppContext = createContext();

const LANG_STORAGE_KEY = 'fynapp-lang';

const getBrowserLang = () => {
    const code = (navigator.language || 'es').slice(0, 2).toLowerCase();
    return code === 'en' ? 'en' : 'es';
};

const getInitialLang = () => {
    const stored = localStorage.getItem(LANG_STORAGE_KEY);
    if (stored === 'en' || stored === 'es') return stored;
    return getBrowserLang();
};

const appReducer = (state, action) => {
    switch (action.type) {
        case 'SET_LANG':
            return { ...state, lang: action.payload };
        default:
            return state;
    }
};

export const AppProvider = ({ children }) => {
    const [appState, dispatch] = useReducer(appReducer, null, () => ({
        lang: getInitialLang(),
    }));

    const setLang = useCallback((payload) => {
        localStorage.setItem(LANG_STORAGE_KEY, payload);
        dispatch({ type: 'SET_LANG', payload });
    }, []);

    const getLanguageObject = useCallback((activeLang, es, en) => {
        if (activeLang === 'es') return es;
        if (activeLang === 'en') return en;
        return es;
    }, []);

    const contextValue = useMemo(() => ({
        ...appState,
        setLang,
        getLanguageObject,
    }), [
        appState,
        setLang,
        getLanguageObject,
    ]);

    return (
        <AppContext.Provider value={contextValue}>
            {children}
        </AppContext.Provider>
    );
};

export const useAppContext = () => {
    return useContext(AppContext);
};